export const getWorkCenterInitialState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
